export const TARGETED_RECIPIENTS = 'targetedRecipients';

export const TARGETED_RECIPIENTS_WITH_SPACE = 'Targeted Recipients';

export const LOCAL_STORAGE_KEY = 'xmEventNotificationStreams';

export const targetedRecipients = {
  id: TARGETED_RECIPIENTS,
  value: TARGETED_RECIPIENTS,
  label: TARGETED_RECIPIENTS_WITH_SPACE,
  name: TARGETED_RECIPIENTS_WITH_SPACE,
};
